export const uniqueNonEmptyStrings = (items) => Array.from(new Set((items || []).map((item) => String(item || '').trim()).filter(Boolean)));

export const getExtractionFailureReasonLabel = (failure, t) => {
  const stage = String(failure?.stage || '').trim();
  const error = String(failure?.error || '').trim();
  const page = Number(failure?.source_page || 0);
  const stageLabelMap = {
    duplicate_file: t ? t('failure.duplicateFile') : '重复文件',
    pdf_to_image: t ? t('failure.pdfToImage') : 'PDF 转图片失败',
    file_prepare: t ? t('failure.filePrepare') : '文件准备失败',
    db_write: t ? t('failure.dbWrite') : '写库失败',
    persistence_skip: t ? t('failure.persistenceSkip') : '入库前校验未通过',
    duplicate_record: t ? t('failure.duplicateRecord') : '重复记录'
  };
  const errorLabelMap = {
    duplicate_uploaded_file: t ? t('failure.duplicateUploaded') : '重复上传，系统已跳过',
    missing_conversion_source_asset_no: t ? t('failure.missingConversionOut') : '缺少转换转出资产编号',
    missing_conversion_target_asset_no: t ? t('failure.missingConversionIn') : '缺少转换转入资产编号',
    missing_asset_no: t ? t('failure.missingAssetNo') : '缺少资产编号'
  };
  const stageLabel = stageLabelMap[stage] || (t ? t('failure.processFailed') : '处理失败');
  const errorLabel = errorLabelMap[error] || error;
  const pageLabel = page > 0 ? (t ? t('failure.pageLabel', { page }) : `第 ${page} 页`) : '';
  if (pageLabel && errorLabel) {
    return `${pageLabel}：${stageLabel}（${errorLabel}）`;
  }
  if (pageLabel) {
    return `${pageLabel}：${stageLabel}`;
  }
  if (errorLabel) {
    return `${stageLabel}（${errorLabel}）`;
  }
  return stageLabel;
};

export const buildFailedFileEntries = (failures, t) => {
  const grouped = new Map();
  (failures || []).forEach((failure) => {
    const fileName = String(failure?.source_file || '').trim();
    if (!fileName) {
      return;
    }
    const nextReason = getExtractionFailureReasonLabel(failure, t);
    const current = grouped.get(fileName) || { fileName, reasons: [] };
    if (nextReason && !current.reasons.includes(nextReason)) {
      current.reasons.push(nextReason);
    }
    grouped.set(fileName, current);
  });
  return Array.from(grouped.values());
};

export const getFilePeriodLabel = (file, extractionItems, t) => {
  const matchedItem = extractionItems.find((item) => item.source_file === file.name && item.data?.date);
  const dateText = matchedItem?.data?.date;
  if (dateText && /^\d{4}-\d{2}-\d{2}$/.test(dateText)) {
    return t ? t('filePeriod.year', { year: dateText.slice(0, 4) }) + t('filePeriod.month', { month: dateText.slice(5, 7) }) : `${dateText.slice(0, 4)}年${dateText.slice(5, 7)}月`;
  }
  if (file.lastModified) {
    const fallbackDate = new Date(file.lastModified);
    const year = fallbackDate.getFullYear();
    const month = String(fallbackDate.getMonth() + 1).padStart(2, '0');
    return t ? t('filePeriod.year', { year }) + t('filePeriod.month', { month }) : `${year}年${month}月`;
  }
  return t ? t('filePeriod.unidentified') : '未识别日期';
};

export const getFileDateLabel = (file, extractionItems, t) => {
  const matchedItem = extractionItems.find((item) => item.source_file === file.name && item.data?.date);
  return matchedItem?.data?.date || (t ? t('filePeriod.waitingOcr') : '待OCR识别');
};

export const getDocumentDateValue = (document) => document.business_date || document.uploaded_at || '';

export const getDocumentPeriodParts = (document, t) => {
  const dateText = getDocumentDateValue(document);
  if (/^\d{4}-\d{2}-\d{2}/.test(dateText)) {
    return {
      year: t ? t('filePeriod.year', { year: dateText.slice(0, 4) }) : `${dateText.slice(0, 4)}年`,
      month: t ? t('filePeriod.month', { month: dateText.slice(5, 7) }) : `${dateText.slice(5, 7)}月`
    };
  }
  return {
    year: t ? t('filePeriod.unidentifiedYear') : '未识别年份',
    month: t ? t('filePeriod.unidentifiedMonth') : '未识别月份'
  };
};

export const getFileKey = (file) => `${file.name}__${file.size}__${file.lastModified}`;

export const clampUnitValue = (value) => Math.min(1, Math.max(0, Number(value || 0)));

export const revokeObjectUrl = (url) => {
  if (String(url || '').startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};
